import { render, staticRenderFns } from "./AutomateProcesses.vue?vue&type=template&id=e27d3ea0&scoped=true"
import script from "./AutomateProcesses.vue?vue&type=script&lang=js"
export * from "./AutomateProcesses.vue?vue&type=script&lang=js"
import style0 from "./AutomateProcesses.vue?vue&type=style&index=0&id=e27d3ea0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d3ea0",
  null
  
)

export default component.exports